module.exports = "<div id=education><div class=study><div class=logo><img src=" + require("../assets/logo-nus.png") + "></div><div class=school>National University of Singapore</div><div class=period>2008-2013</div><div class=desc>Bachelor’s Degree – Computing, communication & media, specialized in interactive media technology.</div></div><div class=study><div class=logo><img src=" + require("../assets/logo-vjc.png") + "></div><div class=school>Victoria Junior College</div><div class=period>2006-2007</div><div class=desc>Computing was taken during junior college.</div></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Education.vue
 ** module id = 220
 ** module chunks = 0
 **/